import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { UserJob } from '../../../signup.types';
import { FIRM_SIZES } from '../../../../../../shared/constants/signupConstants';
import { InjectedIntlProps } from '../../../../doctrine.types';

type Props = {
  jobTitle: string;
  position: string;
  firmSize: string;
  handleJobTitleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  USER_JOBS: Array<UserJob>;
} & InjectedIntlProps;

export class RawSignUpFormStructure extends React.Component<Props> {
  render() {
    const selection /* : ?UserJob */ = this.props.USER_JOBS.find(
      element => element.jobTitle === this.props.jobTitle,
    );
    // do not display position selection if firmSize is "Individuel"
    const isIndividual =
      (this.props.jobTitle === 'Avocat' || this.props.jobTitle === 'Juriste') &&
      this.props.firmSize === 'Individuel';
    return (
      <>
        <div>
          <div className="signup-form__label">
            <FormattedMessage id="signup/routes/user/form/SignUpFormStructure.tsx/1" />
          </div>
          <select
            name="jobTitle"
            value={this.props.jobTitle}
            onChange={this.props.handleJobTitleChange}
            data-test-id="select-job-title"
            required
          >
            <option value="initial" disabled>
              {this.props.intl.formatMessage({
                id: 'signup/routes/user/form/SignUpFormStructure.tsx/2',
              })}
            </option>
            {this.props.USER_JOBS.map(({ jobTitle }) => (
              <option key={jobTitle} value={jobTitle}>
                {jobTitle}
              </option>
            ))}
          </select>
        </div>
        {selection && selection.firmSize && (
          <div>
            <div className="signup-form__label">
              {selection.jobTitle === 'Juriste'
                ? 'Taille de mon équipe juridique'
                : 'Taille de ma structure'}
            </div>
            <select
              name="firmSize"
              value={this.props.firmSize}
              onChange={this.props.handleChange}
              data-test-id="select-firm-size"
              required
            >
              <option value="initial" disabled>
                {this.props.intl.formatMessage({
                  id: 'signup/routes/user/form/SignUpFormStructure.tsx/3',
                })}
              </option>
              {FIRM_SIZES.map(firmSize => (
                <option key={firmSize} value={firmSize}>
                  {firmSize}
                </option>
              ))}
            </select>
          </div>
        )}
        {selection && selection.positions.length > 0 && !isIndividual && (
          <div>
            <div className="signup-form__label">
              <FormattedMessage id="signup/routes/user/form/SignUpFormStructure.tsx/4" />
            </div>
            <select
              name="position"
              value={this.props.position}
              onChange={this.props.handleChange}
              data-test-id="select-position"
              required
            >
              <option value="initial" disabled>
                {this.props.intl.formatMessage({
                  id: 'signup/routes/user/form/SignUpFormStructure.tsx/5',
                })}
              </option>
              {selection.positions.map(position => (
                <option key={position} value={position}>
                  {position}
                </option>
              ))}
            </select>
          </div>
        )}
      </>
    );
  }
}

export const SignUpFormStructure = injectIntl(RawSignUpFormStructure);
